import { API_ENDPOINTS } from "../constants/endpoints";
import { KPI_ENDPOINT_MAP } from "../constants/KpiEnpointMapper";
import api from "../lib/axios";

export const getScreenConfig = (pageName: string) => {
  return api.get(
    `${API_ENDPOINTS.HOME.GET_CONFIGURATION_DETAILS}?pageName=${pageName}`
  );
};

export const getKpiData = (kpiId: number) => {
  const kpiEndpoint = KPI_ENDPOINT_MAP[kpiId];
  return api.get(kpiEndpoint);
};

export const getExploreCountryList = () => {
  return api.get(API_ENDPOINTS.HOME.COUNTRY_EXPLORER);
};
